import {useEffect, useState} from 'react';

export function useIsMounted() {
  const [state, setState] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
    setState(true);
  }, []);

  return state;
}
